function Download() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
      <path d="M479.565-323.044 225.999-576.045l87.436-86.87 104.652 105.782v-282.78h122.957v282.78l104.652-105.782 86.87 86.87-253.001 253.001ZM243.044-120.087q-51.299 0-87.128-35.829t-35.829-87.128v-120h122.957v120h473.912v-120h122.957v120q0 51.348-35.829 87.153-35.829 35.804-87.128 35.804H243.044Z" />
    </svg>
  );
}

export default Download;
